import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import Heading from '../../common/Heading';
import {
  TextInput,
  TextAreaInput,
  AddressInputFields,
} from '../../common/FormFields';
import formStyles from '../../styles/forms.module.scss';
import s from './StepSomeInformation.module.scss';
import FileUploadInput from '../../common/FormFields/FileUploadInput';
import { ALLOWED_FILE_EXTENSIONS } from './FormValidation/ValidationSchema';

function StepSomeInformation() {
  return (
    <section className={s.stepSomeInformation}>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepSomeInformation.title" />
      </Heading>
      <p className={s.introText}>
        <FormattedMessage id="offerWizard.StepSomeInformation.introText" />
      </p>
      <div className={formStyles.formFields}>
        <fieldset>
          <legend className={s.legend}>
            <FormattedMessage id="offerWizard.StepSomeInformation.address" />
          </legend>
          <Field
            name="information.company"
            labelMsg="offerWizard.StepSomeInformation.company.label"
            component={TextInput}
            fullWidth
            labelClass={formStyles.fullWidthField}
            autoComplete="organization"
            required
          />
          <div className={s.address}>
            <AddressInputFields namePrefix="information" isRequired />
          </div>
          <div className={formStyles.fullWidthField}>
            <Field
              name="information.notes"
              labelMsg="offerWizard.StepSomeInformation.notes.label"
              component={TextAreaInput}
              labelHTML={
                <>
                  <legend className={s.legend}>
                    <FormattedMessage id="offerWizard.StepSomeInformation.additionalInformations" />
                  </legend>
                  <FormattedMessage id="offerWizard.StepSomeInformation.additionalInformations.text" />
                </>
              }
            />
          </div>
          <div className={formStyles.inputPairSingle}>
            <Field
              name="information.file"
              component={FileUploadInput}
              allowedExtensions={ALLOWED_FILE_EXTENSIONS}
            />
          </div>
        </fieldset>
      </div>
    </section>
  );
}

export default StepSomeInformation;
